import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  createMigrate,
  MigrationManifest,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from '../slices';
import { facilitatorsApi } from '../api/facilitators';

const migrations: MigrationManifest = {
  0: (state: any) => ({
    ...state,
    vendors: {
      ...state.vendors,
      sortField: 'totalInvoiceSpend',
      sortDirection: 'asc',
    },
  }),
  1: (state: any) => ({
    ...state,
    vendors: {
      ...state.vendors,
      invoicesSortField: 'invoiceDate',
      sortDirection: 'desc',
    },
  }),
};

const persistConfig = {
  key: 'root',
  storage,
  version: 1,
  whitelist: [
    'auth',
    'vendors',
    'clients',
    'divisions',
    'invoiceApprovals',
  ],
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }).concat([
    facilitatorsApi.middleware
  ]),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
